import {
  AcceptTypes,
  WORD_DOCUMENT_MIMETYPES,
  WORD_DOCUMENT_EXTENSIONS,
  IMAGE_MIME_TYPES,
  PDF_DOCUMENT_MIMETYPE,
  POWERPOINT_DOCUMENT_MIMETYPES,
  POWERPOINT_DOCUMENT_EXTENSIONS,
  ACCEPT_TYPE_WORD,
  ACCEPT_TYPE_PDF,
  ACCEPT_TYPE_POWERPOINT,
  ACCEPT_TYPE_IMAGE,
  PDF_EXTENSION,
  DOC_EXTENSION,
  DOCX_EXTENSION,
  PPT_EXTENSION,
  PPTX_EXTENSION,
  JPEG_EXTENSION,
  JPG_EXTENSION,
  PNG_EXTENSION,
  IMAGE_EXTENSIONS,
  ACCEPT_TYPE_RIVE,
  RIVE_EXTENSION,
  ACCEPT_TYPE_GIF,
  GIF_EXTENSION,
  MP3_EXTENSION,
  ACCEPT_TYPE_AUDIO,
  ACCEPT_TYPE_CSV,
  ACCEPT_TYPE_XLSX,
  CSV_EXTENSION,
  XLSX_EXTENSION,
  CSV_MIME_TYPE,
  XLSX_MIME_TYPE,
} from './file-dropper.constants';

export const getAcceptString = (acceptTypes: AcceptTypes) => {
  const mimeTypes: string[] = [];
  acceptTypes.forEach(type => {
    switch (type) {
      case ACCEPT_TYPE_WORD:
        mimeTypes.push(...WORD_DOCUMENT_MIMETYPES, ...WORD_DOCUMENT_EXTENSIONS);
        break;
      case ACCEPT_TYPE_PDF:
        mimeTypes.push(PDF_DOCUMENT_MIMETYPE, PDF_EXTENSION);
        break;
      case ACCEPT_TYPE_IMAGE:
        mimeTypes.push(...IMAGE_MIME_TYPES, ...IMAGE_EXTENSIONS);
        break;
      case ACCEPT_TYPE_RIVE:
        mimeTypes.push(RIVE_EXTENSION);
        break;
      case ACCEPT_TYPE_GIF:
        mimeTypes.push(GIF_EXTENSION);
        break;
      case ACCEPT_TYPE_POWERPOINT:
        mimeTypes.push(
          ...POWERPOINT_DOCUMENT_MIMETYPES,
          ...POWERPOINT_DOCUMENT_EXTENSIONS
        );
        break;
      case ACCEPT_TYPE_AUDIO:
        mimeTypes.push(MP3_EXTENSION);
        break;
      case ACCEPT_TYPE_CSV:
        mimeTypes.push(CSV_MIME_TYPE);
        break;
      case ACCEPT_TYPE_XLSX:
        mimeTypes.push(XLSX_MIME_TYPE);
        break;
    }
  });

  return mimeTypes.join(',');
};

export const getAcceptError = (acceptTypes: AcceptTypes) => {
  const fileExtensions = [];
  if (acceptTypes.includes(ACCEPT_TYPE_WORD))
    fileExtensions.push(DOC_EXTENSION, DOCX_EXTENSION);
  if (acceptTypes.includes(ACCEPT_TYPE_PDF)) fileExtensions.push(PDF_EXTENSION);
  if (acceptTypes.includes(ACCEPT_TYPE_IMAGE))
    fileExtensions.push(JPEG_EXTENSION, JPG_EXTENSION, PNG_EXTENSION);
  if (acceptTypes.includes(ACCEPT_TYPE_POWERPOINT))
    fileExtensions.push(PPT_EXTENSION, PPTX_EXTENSION);

  if (acceptTypes.includes(ACCEPT_TYPE_CSV)) fileExtensions.push(CSV_EXTENSION);
  if (acceptTypes.includes(ACCEPT_TYPE_XLSX))
    fileExtensions.push(XLSX_EXTENSION);

  return `Please try again with a ${
    fileExtensions.length === 1
      ? fileExtensions[0]
      : `${fileExtensions.slice(0, fileExtensions.length - 1).join(', ')} or ${
          fileExtensions[fileExtensions.length - 1]
        }`
  } file`;
};

export const getAcceptExtensions = (acceptTypes: AcceptTypes) => {
  const extensions: string[] = [];
  acceptTypes.forEach(type => {
    switch (type) {
      case ACCEPT_TYPE_PDF:
        extensions.push(PDF_EXTENSION);
        break;
      case ACCEPT_TYPE_IMAGE:
        extensions.push(...IMAGE_EXTENSIONS);
        break;
      case ACCEPT_TYPE_GIF:
        extensions.push(GIF_EXTENSION);
        break;
      case ACCEPT_TYPE_AUDIO:
        extensions.push(MP3_EXTENSION);
        break;
      case ACCEPT_TYPE_CSV:
        extensions.push(CSV_EXTENSION);
        break;
      case ACCEPT_TYPE_XLSX:
        extensions.push(XLSX_EXTENSION);
        break;
    }
  });
  return extensions.join(' ');
};

export function getOptionalProps(accept?: AcceptTypes) {
  const optionalProps: { tabIndex: number; accept?: string } = {
    tabIndex: -1,
  };
  if (accept) {
    optionalProps.accept = getAcceptString(accept);
  }

  return optionalProps;
}
